import React from 'react';
import {connect} from 'react-redux';
import {IconButton} from '@material-ui/core';
import {
    AddBoxOutlined,
    IndeterminateCheckBoxOutlined,
} from '@material-ui/icons';
import {openNotification} from 'Actions/notification';
import {T} from 'Actions/translate';

class ProxyDeliveryStatusTracking extends React.Component {
    state = {
        reason: '',
        remark: '',
        selectedReason: null,
        isHistoryExpanded: false,
    };

    codeCountdownTimer = null;

    handleTextArea = (title, value) => {
        this.setState({remark: value || ''});
    };

    getStatusLable = (status) => {
        const {historyStatusList} = this.props;
        const matchedHistory = (historyStatusList || []).find(
            (item) => item && item.actionStatus === status,
        );
        if (matchedHistory) {
            if (
                matchedHistory.actionStatus === 'HOST_REJECTED' ||
                matchedHistory.actionStatus === 'WAIT_CUSTOMER_RECEIPT'
            ) {
                let hostName = matchedHistory.actionByHostName || '';
                if (matchedHistory.actionStatus === 'HOST_REJECTED') {
                    hostName = hostName + '' + T('proxy_delivery_reject');
                } else if (
                    matchedHistory.actionStatus === 'WAIT_CUSTOMER_RECEIPT'
                ) {
                    hostName = hostName + '' + T('proxy_delivery_delivery');
                }
                return hostName;
            } else if (matchedHistory.actionStatus === 'COMPLETED') {
                return T('shippment_upload_signature_method_customer');
            } else if (matchedHistory.actionStatus === 'CUSTOMER_REJECTED') {
                return T('proxy_delivery_customer_reject');
            }
            return matchedHistory.actionByHostName;
        } else {
            return status;
        }
    };

    previewSignReceipt = (imageUrl) => {
        this.props.previewSignReceiptImage(imageUrl);
    };

    getReasonValue = (key) => {
        const {rejectReasonOptions} = this.props;
        const matchedReason =
            rejectReasonOptions &&
            rejectReasonOptions.length > 0 &&
            rejectReasonOptions.find((item) => item && item.key === key);
        return matchedReason && matchedReason.fullName
            ? matchedReason.fullName
            : key;
    };

    getLastReasonValue = (index) => {
        const {historyStatusList} = this.props;
        if (
            !Array.isArray(historyStatusList) ||
            historyStatusList.length === 0
        ) {
            return false;
        }

        return index === historyStatusList.length - 1;
    };

    toggleHistoryExpanded = () => {
        this.setState((prevState) => ({
            isHistoryExpanded: !prevState.isHistoryExpanded,
        }));
    };

    render() {
        const {historyStatusList = []} = this.props;
        const {isHistoryExpanded} = this.state;
        return (
            <div className="status-operate_recodeMain">
                <ul className="status-operate_recode_date">
                    {historyStatusList.map((statusItem, index) => {
                        if (!isHistoryExpanded && index > 0) {
                            return null;
                        }
                        const isSingleVisibleItem =
                            (!isHistoryExpanded && index === 0) ||
                            this.getLastReasonValue(index);
                        return (
                            <>
                                {
                                    <div className="status-operate_toggle">
                                        {index === 0 && (
                                            <div className="status-operate_toggle-label">
                                                {T('proxy_delivery_sign_info')}
                                            </div>
                                        )}

                                        {historyStatusList.length > 1 &&
                                            index === 0 && (
                                                <IconButton
                                                    className="status-operate_toggle-btn"
                                                    onClick={
                                                        this
                                                            .toggleHistoryExpanded
                                                    }
                                                    size="small"
                                                    aria-label={T(
                                                        isHistoryExpanded
                                                            ? 'shipment_pick_expand_less'
                                                            : 'shipment_pick_expand_more',
                                                    )}>
                                                    {isHistoryExpanded ? (
                                                        <IndeterminateCheckBoxOutlined fontSize="small" />
                                                    ) : (
                                                        <AddBoxOutlined fontSize="small" />
                                                    )}
                                                </IconButton>
                                            )}
                                    </div>
                                }
                                <li
                                    key={`${
                                        statusItem?.actionTime || index
                                    }-${index}`}
                                    className={
                                        isSingleVisibleItem
                                            ? 'status-timeline-item status-timeline-item--single'
                                            : 'status-timeline-item'
                                    }>
                                    <i></i>
                                    <div className="spanList">
                                        <div>
                                            <div className="status-tracking-left">
                                                <div className="tracking-event-status">
                                                    {this.getStatusLable(
                                                        statusItem.actionStatus,
                                                    )}
                                                </div>
                                                {statusItem.actionImgFull ? (
                                                    <span
                                                        className="tracking-preview"
                                                        onClick={() => {
                                                            this.previewSignReceipt(
                                                                statusItem.actionImgFull,
                                                            );
                                                        }}>
                                                        {T(
                                                            'proxy_delivery_signReceipt',
                                                        )}
                                                    </span>
                                                ) : null}
                                            </div>
                                            {(statusItem.reason ||
                                                statusItem.comment) && (
                                                <div className="tracking-reason">
                                                    {statusItem.reason && (
                                                        <div className="reason-value">
                                                            {T(
                                                                'proxy_delivery_reason',
                                                            )}
                                                            {this.getReasonValue(
                                                                statusItem.reason,
                                                            )}
                                                        </div>
                                                    )}
                                                    {statusItem.comment && (
                                                        <div className="reason-value">
                                                            {T(
                                                                'proxy_delivery_remark',
                                                            )}
                                                            {statusItem.comment}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div className="tracking-right">
                                            <span className="tracking-time">
                                                {statusItem.actionTime}
                                            </span>
                                        </div>
                                    </div>
                                </li>
                            </>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {proxyDelivery} = state;
    return {
        statusOptions: proxyDelivery.statusOptions,
    };
};

export default connect(mapStateToProps, {openNotification})(
    ProxyDeliveryStatusTracking,
);
